import styled from '@emotion/styled'
import { Input, Button } from 'antd'
import { colors } from 'style/theme'

export const PreLoginView = styled.div({
	display: 'flex',
	height: '100vh',
	background: 'linear-gradient(45deg, rgba(46,85,159,1) 0%, rgba(23,148,240,1) 100%)',
	justifyContent: 'center',
	flexFlow: 'column'
})

export const StyledPreLoginForm = styled.div({
	borderRadius: '5px',
	padding: 40,
	paddingTop: 0,
	paddingBottom: '1.5rem',
	background: colors.brandWhite,
	width: 400,
	justifySelf: 'center',
	alignSelf: 'center',
	position: 'relative'
})

export const PreLoginTitle = styled.h1({
	fontSize: '1.65rem',
	fontWeight: 400
})

export const PreLoginSubTitle = styled.h2({
	fontSize: 14,
	fontWeight: 400,
	color: colors.brandGray,
	marginBottom: 30
})

export const StyledPreLoginAlert = styled.div({
	marginBottom: 20
})

const BaseInput = {
	height: 36,
	fontSize: 12,
	borderRadius: 4
}
export const PreLoginInput = styled(Input)({
	...BaseInput
})

export const PreLoginInputPassword = styled(Input.Password)({
	input: {
		...BaseInput
	}
})

export const TrialButton = styled(Button)({
	width: '75%',
	height: 42
})

export const PreLoginButton = styled(Button)({
	width: '100%',
	height: 42
})

export const StyledButtonContainer = styled.div`
    display: flex;
	justify-content: center;
	padding-bottom: 10px;
`

export const PreLoginViewFooter = styled.div({
	color: colors.brandDark,
	fontSize: 12,
	fontWeight: 500,
	width: 300,
	marginTop: '1rem',
	textAlign: 'center',
	p: {
		margin: '5px 0'
	},
	a: {
		color: colors.brandLink,
		textDecoration: 'underline',
		':hover': {
			color: colors.brandLinkHover
		}
	}
})
